import usePayment from 'attendee/Billing/Payments/usePayment'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {routes} from 'routes/routes'

export default function useProductPayment(productId: number | null) {
  const {newPayment} = usePayment()
  const navigate = useLocalizedNavigate()

  const onSuccess = () => {
    navigate(routes.purchases)
  }

  const payment = (data?: {}) => {
    return newPayment(
      `api/payment/product/${productId}/buy`,
      `api/payment/product/${productId}/confirmation`,
      data ?? {},
      onSuccess,
    )
  }

  return {
    payment,
  }
}
